import React, { useState, useEffect, useCallback } from "react";
import { debounce } from "lodash";
import { SelectField } from "@unite-us/app-components";
import { Link } from "react-router-dom";
import { getEhrRoute } from "../../../utils/getEhrRoute";
import { providerNameQuery } from "../../../../hooks/providerNameQuery";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function NewMessageHeader(props) {
  const {
    onEmployeeChange,
    subjectType,
    subjectId,
    source,
    topicTitle,
    personName,
    personId,
    headerLinksEnabled,
    apiMessagingService,
    setShowNewMessage,
    toast,
    navigate
  } = props;
  const [initOptions, setInitOptions] = useState();
  const [selectFieldValue, setSelectFieldValue] = useState();
  const [selectFieldDirty, setSelectFieldDirty] = useState(false);
  const [isLoadingRecipients, setIsLoadingRecipients] = useState(true);
  const getEmployees = async function () {
    let term = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
    try {
      const response = await apiMessagingService.get("/employees?subject=".concat(subjectId, "&subject_type=").concat(subjectType).concat(term ? "&filter[query]=".concat(term) : ""));
      return response.data.employees;
    } catch (e) {
      setShowNewMessage(false);
      toast.error(404, 'It was not possible to create the new conversation');
      navigate('/message-center');
      console.error(e);
      return [];
    }
  };
  const getPossibleEmployees = async (searchTerm, size) => {
    const dataArray = await getEmployees(searchTerm, size);
    setIsLoadingRecipients(false);
    let formattedOptions = [];
    const uniqueProviderIds = [...new Set(dataArray === null || dataArray === void 0 ? void 0 : dataArray.map(dataItem => dataItem.relationships.provider.data.id))];
    if (uniqueProviderIds.length > 0 && dataArray.length > 0) {
      const providersNamesMap = await providerNameQuery(uniqueProviderIds);
      for (let item of dataArray) {
        let work_title = item.attributes.work_title ? " - " + item.attributes.work_title : '';
        const isPrimaryWorker = item['is_primary_worker'];
        const isCareCoordinator = item['is_care_coordinator'];
        if (isPrimaryWorker) {
          work_title = work_title + " - Primary Worker";
        }
        if (isCareCoordinator) {
          work_title = work_title + " - Care Coordinator";
        }
        formattedOptions.push({
          id: item.id,
          label: "".concat(item.attributes.first_name, " ").concat(item.attributes.last_name, " (").concat(providersNamesMap[item.relationships.provider.data.id], ")").concat(work_title)
        });
      }
    }
    return formattedOptions;
  };
  const fetcher = async searchTerm => {
    if (subjectId && subjectType) {
      let response = await getPossibleEmployees(searchTerm, 50);
      setInitOptions(response);
      return new Promise(resolve => {
        resolve({
          options: response
        });
      });
    }
  };
  const onChange = value => {
    setSelectFieldDirty(true);
    setSelectFieldValue(value.id);
    onEmployeeChange(value.id);
  };
  const isEhr = source === 'emr';
  const facesheetLink = isEhr ? getEhrRoute('client', personId, subjectType, subjectId) : "/facesheet/".concat(personId);
  const topicLink = isEhr ? getEhrRoute('topic', personId, subjectType, subjectId) : "/facesheet/".concat(personId, "/").concat(subjectType, "s");
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("div", {
      className: "new-message-header",
      children: [/*#__PURE__*/_jsx("div", {
        className: "input-group w-full pb-4",
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(SelectField, {
            id: "message-recipient-selectfield",
            label: "To",
            value: selectFieldValue,
            valueKey: "id",
            labelKey: "label",
            loadingText: "Loading...",
            inline: false,
            shouldSort: false,
            placeholder: "Search for a recipient...",
            dirty: selectFieldDirty,
            loadOptions: debounce(fetcher, 200),
            loadOnMount: true,
            options: initOptions,
            onChange: value => onChange(value),
            disabled: isLoadingRecipients
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "conversation-data flex flex-row -mt-3",
        children: [/*#__PURE__*/_jsx("p", {
          className: "font-medium-font text-base",
          children: "Client: "
        }), /*#__PURE__*/_jsxs("p", {
          className: "px-2 text-base",
          children: [personName && headerLinksEnabled ? /*#__PURE__*/_jsx(Link, {
            className: "ml-1 text-action-blue font-regular-font text-base",
            reloadDocument: true,
            to: facesheetLink,
            children: personName
          }) : /*#__PURE__*/_jsx("span", {
            className: "ml-1 text-action-blue font-regular-font text-base",
            children: personName
          }), !personName && /*#__PURE__*/_jsx(React.Fragment, {
            children: "Loading..."
          })]
        }), /*#__PURE__*/_jsx("span", {
          children: " | "
        }), /*#__PURE__*/_jsx("p", {
          className: "px-2 font-medium-font text-base",
          children: " Topic: "
        }), /*#__PURE__*/_jsxs("p", {
          className: "text-base",
          children: [" ", topicTitle && headerLinksEnabled ? /*#__PURE__*/_jsx(Link, {
            className: "topic-link text-action-blue font-regular-font text-base",
            reloadDocument: true,
            to: topicLink,
            children: topicTitle
          }) : /*#__PURE__*/_jsx("span", {
            className: "ml-1 text-action-blue font-regular-font text-base",
            children: topicTitle
          }), !topicTitle && /*#__PURE__*/_jsx(React.Fragment, {
            children: "Loading..."
          })]
        })]
      })]
    })
  });
}
export default NewMessageHeader;
//# sourceMappingURL=newMessageHeader.js.map